import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RepoEntry } from '../../../model/v3/documents';

@Injectable({
  providedIn: 'root',
})
export class DocumentsV3RestService {
  constructor(private http: HttpClient) {}

  private baseUrl(schoolId: number, path: string = ''): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}/documents${path}`;
  }

  listDocumentRepository(schoolId: number): Observable<RepoEntry> {
    return this.http.get<RepoEntry>(this.baseUrl(schoolId));
  }

  getDocumentLink(schoolId: number, relativePath: string): Observable<string> {
    const normalizedPath = relativePath
      ? '/' + relativePath.split('/').map(encodeURIComponent).join('/')
      : '';
    return this.http.get(this.baseUrl(schoolId, normalizedPath), {responseType: "text"});
  }

  refreshDocuments(schoolId: number): Observable<void> {
    const params = new HttpParams().set('action', 'refresh');
    return this.http.post<void>(this.baseUrl(schoolId), null, { params });
  }
}
